// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"7a6ff1c4","142":"099c33b6","167":"37f29262","169":"f1938e25","246":"613b5e0e","332":"f6d1fa51","565":"c58a5490","879":"674c0c47","989":"59f4879c"}[chunkId] + ".chunk.js";
};